module.exports = __webpack_public_path__ + "static/media/reap-benefit-logo.cf4f6b48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reap-benefit-logo.png
// module id = 1387
// module chunks = 0